import { Inject, NgModule } from '@angular/core';
import { ToastModule } from '../toast/toast.module';
import { ToastService } from '../toast/services/toast.service';
import { ToastColorEnum } from '../toast/enums/toast-color.enum';

@NgModule({
    imports: [
        ToastModule,
    ],
    providers: [
        {
            provide: 'Window',
            useValue: window,
        },
    ],
})

export class LogErrorModule {
    constructor(
        @Inject('Window') private readonly window,
        private readonly toastService: ToastService,
    ) {
        window.onerror = (a, b, c, d, error) => {
            this.toastService.open({
                duration: 100000,
                title: 'Error in browser',
                description: error.details,
                message: error.message || error.error,
                color: ToastColorEnum.danger,
            });
        };
    }
}
